
<h2 for="label">{{variables.manageGCM}}</h2>

<!-- select for region -->
<label class="mb-2">{{variables.selectRegion1}}</label>
<div class="form-group mb-5">
  <div style="display: flex;">
    <div style="width: 100%;">
      <form [formGroup]="formGroup1">
        <mat-form-field class="form-field" appearance="fill">
          <mat-select placeholder="" (selectionChange)="changeRegion($event)" formControlName="regionCtrl">
            <mat-option>
              <ngx-mat-select-search placeholderLabel={{variables.search}} noEntriesFoundLabel={{variables.noRegionFound}}  formControlName="regionsFilterCtrl"></ngx-mat-select-search>
            </mat-option>
            @for (item of filteredRegions; track item; let i = $index) {
              <mat-option [value]="item.value">
                <span class="flag-icon flag-icon-{{item.value}}"></span>
                <span style="margin-left: 6px">{{item.name}}</span>
              </mat-option>
            }
            <!-- <mat-option *ngFor="let item of filteredRegions;" [value]="item.name">
            {{item.name}}
          </mat-option> -->
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <!-- button to add region -->
  <div>
    <app-button typeBtn="primary" (click)="addRegion()" message="{{variables.addRegion}}"></app-button>
  </div>
</div>
</div>


<!-- manage gcm's table -->
@if (showTable) {
  <div>
    <div class="estimates mb-5">
      <div class="mat-elevation-z0">
        <table matSort mat-table [dataSource]="dataSourceGCM" class="">
          <!-- Name -->
          <ng-container matColumnDef="gcm">
            <mat-header-cell *matHeaderCellDef>{{variables.gcm}}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.gcm}}</mat-cell>
          </ng-container>
          <!-- DAS ID -->
          <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef>{{variables.costHour}} </mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.cost}}€</mat-cell>
          </ng-container>
          <!-- ACTIONS -->
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span (click)="editGCM(element)" class="buttons" style="margin-right: 10px;">
                <div class="icon-bg">
                  <mat-icon>edit</mat-icon>
                </div>
              </span>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
        </table>
      </div>
      <br>
        <div>
          <div style="float: right;">
            <app-button typeBtn="primary" (click)="saveGCM()"  message="{{variables.save1}}"></app-button>
          </div>
        </div>
      </div>
    </div>
  }


